import AuerRequestRmaState, { RmaFormState } from "@auer-steel/Store/Pages/RequestRma/AuerRequestRmaState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: AuerRequestRmaState = {
    formState: {},
    isSubmitting: false,
};

const reducer = {
    "Pages/AuerRequestRma/BeginSubmit": (draft: Draft<AuerRequestRmaState>) => {
        draft.isSubmitting = true;
    },
    "Pages/AuerRequestRma/EndSubmit": (draft: Draft<AuerRequestRmaState>) => {
        draft.isSubmitting = false;
    },
    "Pages/AuerRequestRma/UpdateFields": (draft: Draft<AuerRequestRmaState>, action: { parameter: RmaFormState }) => {
        draft.formState = action.parameter;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
